import { render, staticRenderFns } from "./BMI.vue?vue&type=template&id=7ee3d5ca&"
import script from "./BMI.vue?vue&type=script&lang=js&"
export * from "./BMI.vue?vue&type=script&lang=js&"
import style0 from "./BMI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports